/* Pawtraitco theme scripts, no dependencies. */
(function () {
  'use strict';

  var theme = window.theme || {};

  /* ---------- Helpers ---------- */
  /* Phone photos are 3-6 MB; shrink them in the browser (max 2400px, JPEG) so Add to cart uploads in a second, not five.
     Starts as soon as a photo is picked; the original is used if anything goes wrong. */
  var shrunk = new WeakMap();
  function shrinkPhoto(file) {
    if (!file || !/^image\/(jpeg|png|webp|heic|heif)/i.test(file.type) || file.size < 1200000 || !window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file).then(function (img) {
      var max = 2400, scale = Math.min(1, max / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      return new Promise(function (res) { c.toBlob(function (b) { res(b && b.size < file.size ? new File([b], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.9); });
    }).catch(function () { return file; });
  }
  function preparePhoto(input) {
    var f = input && input.files && input.files[0];
    if (!f) return Promise.resolve(null);
    var cached = shrunk.get(input);
    if (cached && cached.src === f) return cached.p;
    var p = shrinkPhoto(f);
    shrunk.set(input, { src: f, p: p });
    return p;
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('input[type="file"][name^="properties[Pet photo"]')) preparePhoto(e.target); });

  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
        default: return withDelimiters(value, 2, ',', '.');
      }
    }).replace(/([.,])00(?!\d)/, '');
  }

  function trapFocus(container, event) {
    if (event.key !== 'Tab') return;
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* ---------- Deferred images: fill in below-the-fold images once the main image has loaded,
     so on slow phone connections the hero isn't sharing bandwidth with pictures nobody can see yet ---------- */
  function initDeferred() {
    var done = false;
    function go() {
      if (done) return; done = true;
      document.querySelectorAll('template[data-defer]').forEach(function (tpl) { tpl.replaceWith(tpl.content.cloneNode(true)); });
    }
    var hero = document.querySelector('img[fetchpriority="high"]');
    if (hero && !hero.complete) {
      hero.addEventListener('load', function () { setTimeout(go, 100); }, { once: true });
      hero.addEventListener('error', go, { once: true });
      setTimeout(go, 5000);
    } else {
      go();
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('js-reveal');
    var observer = initReveal.observer || (initReveal.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          initReveal.observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }));
    (root || document).querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    var header = drawer.closest('.site-header');
    drawer.addEventListener('toggle', function () {
      if (drawer.open && header) {
        document.documentElement.style.setProperty('--header-bottom', Math.round(header.getBoundingClientRect().bottom) + 'px');
      }
      document.body.classList.toggle('no-scroll', drawer.open);
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.menu-drawer__panel a')) drawer.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) { drawer.open = false; drawer.querySelector('summary').focus(); }
    });
  }

  /* ---------- One-shot feedback animations (never loop; CSS turns them off for reduced motion) ---------- */
  function pop(el, cls) {
    if (!el) return;
    cls = cls || 'is-popped';
    el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, 700);
  }
  function nudge(el) { pop(el, 'is-nudged'); }

  /* ---------- Gentle fade-up for lower product-page sections (visible by default; only below-the-fold sections animate) ---------- */
  function initSectionFade() {
    if (!document.body.classList.contains('template-product') || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = document.querySelectorAll('#reviews .section-head, [id*="__how"] .rail__item, #faq .product-faq, [id*="__ugc"] .rail__item, [id*="__ugc"] .section-head, [id*="__how"] .section-head');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 10% 0px' });
    targets.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('pu-fade');
      el.style.setProperty('--pu-fade-delay', ((el.classList.contains('rail__item') ? (i % 4) : 0) * 60) + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: null,
    lastFocus: null,

    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      var self = this;
      this.creditLock();
      if (document.querySelector('[data-cart-page]')) self.tidy();

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cart-toggle]');
        if (toggle && self.drawer && !document.querySelector('[data-cart-page]')) {
          e.preventDefault();
          self.open();
          return;
        }
        if (e.target.closest('[data-cart-close]')) { self.close(); return; }
        var upgradeBtn = e.target.closest('[data-cart-upgrade]');
        if (upgradeBtn) { self.upgrade(upgradeBtn); return; }
        var qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          self.change(qtyBtn.dataset.line, parseInt(qtyBtn.dataset.qty, 10));
        }
      });

      document.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-cart-remove-extra]');
        if (rm) { e.preventDefault(); self.removeExtra(rm); }
      });
      // Bag drawer: desk-size copy (same photo and details as the poster)
      document.addEventListener('click', function (e) {
        var desk = e.target.closest('[data-bag-desk]');
        if (desk) {
          var props = {};
          try { props = JSON.parse(desk.dataset.props || '{}'); } catch (err) {}
          desk.disabled = true; desk.textContent = 'Adding…';
          self.post(theme.routes.cartAdd, { items: [{ id: parseInt(desk.dataset.bagDesk, 10), quantity: 1, properties: props }] })
            .catch(function () { desk.disabled = false; desk.textContent = '+ Add'; });
          return;
        }
        if (e.target.closest('[data-bag-code-remove]')) self.code('');
      });
      document.addEventListener('submit', function (e) {
        var f = e.target.closest('[data-bag-code]');
        if (!f) return;
        e.preventDefault();
        var code = (f.elements.code.value || '').trim();
        if (code) self.code(code);
      });
      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-input]');
        if (input) self.change(input.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
        var addon = e.target.closest('[data-cart-addon]');
        if (addon) self.toggleAddon(addon.dataset.cartAddon, addon.checked, addon);
      });

      document.addEventListener('keydown', function (e) {
        if (!self.isOpen()) return;
        if (e.key === 'Escape') self.close();
        else trapFocus(self.drawer.querySelector('[data-cart-panel]'), e);
      });
    },

    isOpen: function () { return this.drawer && this.drawer.classList.contains('is-open'); },

    tidy: function () {
      var self = this;
      return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        var posters = cart.items.filter(function (i) { return i.handle !== 'order-extras'; });
        var refs = {}; posters.forEach(function (i) { if (i.properties && i.properties._extras) refs[i.properties._extras] = 1; });
        var orphans = {};
        cart.items.forEach(function (i) { if (i.handle !== 'order-extras') return; var l = i.properties && i.properties._extras; if ((l && !refs[l]) || (!l && !posters.length)) orphans[i.key] = 0; });
        if (!Object.keys(orphans).length) return;
        return fetch(theme.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: orphans, sections: 'cart-drawer' }) })
          .then(function (r) { return r.json(); })
          .then(function (data) { if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; } if (data.sections) self.render(data.sections['cart-drawer']); });
      }).catch(function () {});
    },

    open: function () {
      if (!this.drawer) { window.location.href = theme.routes.cart; return; }
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.tidy();
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      document.body.classList.add('cart-open');
      var panel = this.drawer.querySelector('[data-cart-panel]');
      setTimeout(function () { panel.focus(); }, 50);
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      document.body.classList.remove('cart-open');
      if (this.lastFocus) this.lastFocus.focus();
    },

    busy: function (on) {
      var el = document.querySelector('[data-cart-page]') || (this.drawer && this.drawer.querySelector('[data-cart-panel]'));
      if (el) el.classList.toggle('is-busy', on);
    },

    change: function (line, quantity) {
      var self = this;
      self.busy(true);
      return fetch(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign(String(line).indexOf(':') > -1 ? { id: line } : { line: parseInt(line, 10) }, { quantity: quantity, sections: 'cart-drawer' }))
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // Removing a poster also removes the extras that were added with it
          var refs = {};
          (data.items || []).forEach(function (i) { if (i.handle !== 'order-extras' && i.properties && i.properties._extras) refs[i.properties._extras] = 1; });
          var orphans = {};
          var posters = (data.items || []).filter(function (i) { return i.handle !== 'order-extras'; }).length;
          (data.items || []).forEach(function (i) {
            if (i.handle !== 'order-extras') return;
            var linked = i.properties && i.properties._extras;
            // Pet / digital extras go with their poster; order-level extras (priority, transit) go when no poster is left
            if ((linked && !refs[linked]) || (!linked && !posters)) orphans[i.key] = 0;
          });
          if (Object.keys(orphans).length) {
            return fetch(theme.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: orphans, sections: 'cart-drawer' }) }).then(function (r) { return r.json(); });
          }
          return data;
        })
        .then(function (data) {
          if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
          if (data.sections) self.render(data.sections['cart-drawer']);
          self.busy(false);
        })
        .catch(function () { self.busy(false); });
    },

    // Remove a pet / digital tag and keep the poster's order details in step (Pets, Digital file)
    removeExtra: function (btn) {
      var self = this, parentKey = btn.dataset.parent, kind = btn.dataset.kind;
      self.busy(true);
      fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.cartRemoveExtra, quantity: 0 }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var parent = (cart.items || []).find(function (i) { return i.key === parentKey; });
          if (!parent) return;
          var props = Object.assign({}, parent.properties || {});
          if (kind === 'pets') delete props['Pets']; else delete props['Digital file'];
          return fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: parentKey, quantity: parent.quantity, properties: props }) });
        })
        .then(function () { return fetch(window.location.pathname + '?sections=cart-drawer'); })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
          if (data['cart-drawer']) self.render(data['cart-drawer']);
          self.busy(false);
        })
        .catch(function () { self.busy(false); });
    },

    // Order-level extras in the cart (priority preview, transit protection): add one, or remove it
    toggleAddon: function (variantId, on, input) {
      var self = this;
      var row = input && input.closest('.cart-addon, .vip-pass, .bag-extra');
      if (row) { row.classList.add('is-pending'); row.classList.toggle('is-on', on); }
      if (input) input.disabled = true;
      var req = on
        ? fetch(theme.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }) })
        : fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            var line = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
            return line && fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 }) });
          });
      return Promise.resolve(req)
        .then(function () { return fetch(window.location.pathname + '?sections=cart-drawer'); })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
          // Swap in the new totals without the fade, keeping the shopper's scroll position
          var body = self.drawer && self.drawer.querySelector('.drawer__body');
          var top = body ? body.scrollTop : 0;
          if (data['cart-drawer']) self.render(data['cart-drawer']);
          var nb = self.drawer && self.drawer.querySelector('.drawer__body');
          if (nb) nb.scrollTop = top;
        })
        .catch(function () {
          if (row) row.classList.remove('is-pending');
          if (input) { input.disabled = false; input.checked = !on; if (row) row.classList.toggle('is-on', !on); }
        });
    },

    // POST to the cart API, then redraw the drawer keeping the scroll position
    post: function (url, payload) {
      var self = this;
      var body = self.drawer && self.drawer.querySelector('.drawer__body');
      var top = body ? body.scrollTop : 0;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: 'cart-drawer' }, payload)) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (data) {
          if (document.querySelector('[data-cart-page]')) { window.location.reload(); return data; }
          if (data.sections) self.render(data.sections['cart-drawer']);
          var nb = self.drawer && self.drawer.querySelector('.drawer__body');
          if (nb) nb.scrollTop = top;
          return data;
        });
    },

    // Apply a discount code in the bag ('' clears codes). Shopify keeps unusable codes, so drop those and say why.
    code: function (code) {
      var self = this;
      self.busy(true);
      return self.post(theme.routes.cartUpdate, { discount: code })
        .then(function (cart) {
          var bad = code && !(cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
          if (!bad) return;
          return self.post(theme.routes.cartUpdate, { discount: '' }).then(function () {
            var msg = self.drawer && self.drawer.querySelector('[data-bag-code-msg]');
            if (msg) msg.textContent = 'That code doesn\'t work for this order.';
          });
        })
        .catch(function () {})
        .then(function () { self.busy(false); });
    },

    upgrade: function (btn) {
      // Swap a digital line for a print, keeping the photo, name and notes.
      var self = this;
      var props = {};
      try { props = JSON.parse(btn.dataset.props || '{}'); } catch (err) {}
      if (Array.isArray(props)) props = props.reduce(function (o, p) { o[p[0]] = p[1]; return o; }, {});
      self.busy(true);
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1, properties: props }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return self.change(btn.dataset.key, 0); })
        .catch(function () { self.busy(false); });
    },

    render: function (html) {
      if (!html || !this.drawer) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-panel]');
      var panel = this.drawer.querySelector('[data-cart-panel]');
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      var countSource = doc.querySelector('[data-cart-count-source]');
      if (countSource) this.setCount(parseInt(countSource.textContent, 10) || 0);
      this.creditLock();
    },

    // Pop-up credit (PAW code) in the cart but under its $79 minimum: show how much more unlocks it
    creditLock: function () {
      var slots = document.querySelectorAll('[data-credit-lock]');
      if (!slots.length) return;
      fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        var dc = (cart.discount_codes || []).filter(function (d) { return /^PAW/i.test(d.code) && !d.applicable; })[0];
        slots.forEach(function (el) {
          if (!dc) { el.hidden = true; return; }
          var short = 7900 - cart.items_subtotal_price;
          el.querySelector('[data-credit-lock-title]').textContent = short > 0 ? 'Add ' + formatMoney(short).replace(/\.00$/, '') + ' to unlock your $15' : 'Your $15 store credit';
          el.querySelector('[data-credit-lock-code]').textContent = dc.code.toUpperCase();
          el.hidden = false;
        });
      }).catch(function () {});
    },

    setCount: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        if (count > (parseInt(el.textContent, 10) || 0)) { var icon = el.closest('a, button') || el; pop(icon, 'is-bounced'); }
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
  };

  /* ---------- Product form ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;

    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var groups = Array.prototype.slice.call(section.querySelectorAll('[data-option-group]'));
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var noteEl = section.querySelector('[data-price-note]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var errorEl = form.querySelector('[data-form-error]');
    var upload = form.querySelector('[data-upload]');
    var fileInput = upload && upload.querySelector('input[type="file"]');

    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    var quickPicks = Array.prototype.slice.call(section.querySelectorAll('[data-quick-pick]'));
    var moreToggle = section.querySelector('[data-more-toggle]');
    var sizePeek = section.querySelector('[data-size-peek]');
    var moreBox = section.querySelector('[data-more-options]');
    var SIZES_LABEL = 'More sizes';
    var moreLabel = moreToggle && moreToggle.querySelector('[data-more-label]');
    var selected = current.options.slice();
    var wz = section.querySelector('[data-wz]');   // 3-step wizard (display type, size, photo)

    function isDigital(value) { return /digital|download/i.test(value || ''); }

    /* Guided flow: after a format or size tap, bring the next step into view */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function nextAfterChoice() {
      // Photo step if they haven't added one yet, otherwise the Add to cart button
      if (upload && !(fileInput && fileInput.files && fileInput.files.length)) return upload.closest('.field-group') || upload;
      return section.querySelector('[data-buy-anchor]');
    }
    function guideTo(el, flash) {
      if (!el) return;
      // Wait for the tap feedback and the sizes box opening to settle before measuring
      setTimeout(function () {
        var header = document.querySelector('.section-header');
        var headerH = header ? header.getBoundingClientRect().height : 0;
        var r = el.getBoundingClientRect();
        var room = window.innerHeight - headerH;
        // Land the step in the middle of the visible area (or near the top if it's taller than the screen)
        var want = r.height < room - 32 ? headerH + (room - r.height) / 2 : headerH + 16;
        var dist = r.top - want;
        if (flash) attention(el);
        if (Math.abs(dist) < 24) return;
        smoothScrollBy(dist);
      }, 320);
    }
    function smoothScrollBy(dist) {
      var startY = window.scrollY;
      var maxY = document.documentElement.scrollHeight - window.innerHeight;
      var target = Math.max(0, Math.min(maxY, startY + dist));
      if (reduceMotion) { window.scrollTo(0, target); return; }
      var change = target - startY;
      var duration = Math.min(900, Math.max(520, Math.abs(change) * 0.9));
      var t0 = null, stopped = false;
      function stop() { stopped = true; }
      // Hand control back the moment the shopper touches or scrolls
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, stop, { once: true, passive: true }); });
      function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
      function step(now) {
        if (stopped) return;
        if (t0 === null) t0 = now;
        var t = Math.min(1, (now - t0) / duration);
        window.scrollTo(0, startY + change * ease(t));
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    /* Extras: pet count and digital file add-on (variants of the hidden "Order extras" product) */
    var petBox = section.querySelector('[data-pet-count]');
    var digitalBox = section.querySelector('[data-digital-addon]');
    var extraUploads = section.querySelector('[data-extra-uploads]');
    function chosenAddons() {
      var list = [];
      var pet = petBox && petBox.querySelector('input:checked[data-addon]');
      if (pet) list.push({ id: pet.dataset.addon, price: parseFloat(pet.dataset.addonPrice), label: 'pets', count: pet.value });
      var dig = digitalBox && !digitalBox.hidden && digitalBox.querySelector('input:checked[data-addon]');
      if (dig) list.push({ id: dig.dataset.addon, price: parseFloat(dig.dataset.addonPrice), label: 'digital' });
      return list;
    }
    function addonCents() { return chosenAddons().reduce(function (t, a) { return t + Math.round(a.price); }, 0); }  // data-addon-price is in cents
    function syncPets() {
      if (!petBox) return;
      var picked = petBox.querySelector('input:checked');
      var n = picked ? parseInt(picked.value, 10) : 1;
      petBox.querySelector('[data-pet-note]').hidden = n < 2;
      if (extraUploads) {
        extraUploads.hidden = n < 2;
        extraUploads.querySelectorAll('[data-extra-upload]').forEach(function (u) { u.hidden = parseInt(u.dataset.extraUpload, 10) > n; });
      }
      if (typeof renderStack === 'function') renderStack();
    }
    if (petBox) petBox.addEventListener('change', function () { syncPets(); render(); });
    if (digitalBox) digitalBox.addEventListener('change', function () { render(); });
    if (extraUploads) extraUploads.querySelectorAll('[data-extra-upload]').forEach(function (label) {
      var input = label.querySelector('input[type="file"]');
      var icon = label.querySelector('[data-x-icon]'), text = label.querySelector('[data-x-text]');
      var icon0 = icon.innerHTML, text0 = text.innerHTML, k = label.dataset.extraUpload;
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        if (!f) { label.classList.remove('is-filled'); icon.innerHTML = icon0; text.innerHTML = text0; renderStack(); return; }
        label.classList.add('is-filled');
        if (/^image\//.test(f.type)) { icon.innerHTML = ''; var im = document.createElement('img'); im.alt = ''; im.src = photoUrl(input); icon.appendChild(im); }
        else icon.textContent = '✓';
        text.innerHTML = '<strong>Pet ' + k + '\u2019s photo added</strong><small>Looking good! Tap to change photo</small>';
        renderStack();
      });
    });

    function attention(el) {
      el.classList.remove('is-attention'); void el.offsetWidth; el.classList.add('is-attention');
      setTimeout(function () { el.classList.remove('is-attention'); }, 1800);
    }

    function valuesFor(index) {
      // Values of option `index` that exist given the options chosen before it.
      return variants.filter(function (v) {
        for (var i = 0; i < index; i++) if (v.options[i] !== selected[i]) return false;
        return true;
      }).map(function (v) { return v.options[index]; });
    }

    function resolve() {
      // Make each later option valid for the earlier choices, preferring available variants.
      for (var i = 1; i < selected.length; i++) {
        var valid = valuesFor(i);
        if (valid.indexOf(selected[i]) === -1) {
          var available = variants.filter(function (v) {
            for (var j = 0; j < i; j++) if (v.options[j] !== selected[j]) return false;
            return v.available;
          });
          var preferred = data.preferredSize && available.filter(function (v) { return v.options[i] === data.preferredSize; })[0];
          selected[i] = preferred ? preferred.options[i] : (available.length ? available[0].options[i] : valid[0]);
        }
      }
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
    }

    function render() {
      var variant = resolve();

      var visibleSteps = 0;
      groups.forEach(function (group) {
        var index = parseInt(group.dataset.optionIndex, 10);
        var valid = index === 0 ? null : valuesFor(index);
        var unique = valid ? valid.filter(function (v, i, a) { return a.indexOf(v) === i; }) : null;
        // Hide follow-up groups with a single choice (e.g. "Size" for a digital file).
        group.hidden = !!(unique && unique.length <= 1);
        if (!group.hidden) visibleSteps++;
        group.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var value = btn.dataset.optionValue;
          btn.setAttribute('aria-pressed', value === selected[index] ? 'true' : 'false');
          if (valid) btn.hidden = valid.indexOf(value) === -1;
          var match = variants.filter(function (v) {
            for (var i = 0; i < index; i++) if (v.options[i] !== selected[i]) return false;
            return v.options[index] === value;
          });
          btn.classList.toggle('is-unavailable', match.length > 0 && !match.some(function (v) { return v.available; }));
          var cardPrice = btn.querySelector('[data-card-price]');
          if (cardPrice) {
            var atSize = variants.filter(function (v) { return v.options[0] === value && v.options[1] === selected[1]; })[0];
            var all = variants.filter(function (v) { return v.options[0] === value; });
            var min = Math.min.apply(null, all.map(function (v) { return v.price; }));
            cardPrice.textContent = atSize ? formatMoney(atSize.price).replace(/\.00$/, '') : (all.length > 1 ? 'From ' : '') + formatMoney(min).replace(/\.00$/, '');
          }
          var pricePill = btn.querySelector('[data-pill-price]');
          if (pricePill) {
            var exact = match.filter(function (v) { return v.options.every(function (o, i) { return i <= index || o === selected[i]; }); })[0] || match[0];
            pricePill.textContent = exact ? formatMoney(exact.price).replace(/\.00$/, '') : '';
          }
        });
      });

      var stepsBefore = quickPicks.length ? 1 : visibleSteps;
      var uploadStep = section.querySelector('[data-upload-step]');
      if (uploadStep) uploadStep.textContent = stepsBefore + 1;
      var cardStep = section.querySelector('[data-card-step]');
      if (cardStep) cardStep.textContent = stepsBefore + 2;
      quickPicks.forEach(function (btn) {
        var opts = JSON.parse(btn.dataset.options);
        var on = opts[0] === selected[0];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        // The chosen format's card follows the size picked under "Other sizes"
        var shown = on && variant ? variant : variants.filter(function (v) { return v.options.join('|') === opts.join('|'); })[0];
        var sizeEl = btn.querySelector('[data-pick-size]'), priceEl2 = btn.querySelector('[data-pick-price]');
        if (shown && sizeEl) sizeEl.textContent = shown.options[1];
        if (shown && priceEl2) priceEl2.textContent = formatMoney(shown.price).replace(/\.00$/, '');
        if (on) {
          var specEl = section.querySelector('[data-pick-spec]');
          if (specEl && btn.dataset.spec) specEl.textContent = btn.dataset.spec;
          if (shown) btn.setAttribute('aria-label', btn.querySelector('.quick-pick__name').firstChild.textContent.trim() + ', ' + formatMoney(shown.price).replace(/\.00$/, ''));
        }
      });
      section.classList.toggle('is-digital', isDigital(selected[0]));
      var sum = section.querySelector('[data-pick-summary]');
      if (sum && variant) {
        var f = variant.options[0];
        sum.querySelector('[data-sum-name]').textContent = /framed/i.test(f) ? 'Framed print' : (isDigital(f) ? 'Digital file' : 'Art print');
        var sz = sum.querySelector('[data-sum-size]');
        sz.hidden = isDigital(f);
        if (!isDigital(f)) sz.textContent = ' · ' + variant.options[1];
      }
      if (sizePeek) {
        sizePeek.hidden = isDigital(selected[0]) || (moreBox && !moreBox.hidden);
        if (variant && !isDigital(variant.options[0])) {
          sizePeek.querySelector('[data-size-peek-value]').textContent = variant.options[1];
          var idx = ['15', '30', '45', '60'].indexOf((variant.options[1].match(/^\d+/) || [''])[0]);
          sizePeek.querySelectorAll('.size-peek__shapes i').forEach(function (el, n) { el.classList.toggle('is-on', n === idx); });
        }
      }
      if (moreToggle) {
        var digitalNow = isDigital(selected[0]);
        moreToggle.hidden = digitalNow;
        if (digitalNow && moreBox && !moreBox.hidden) { moreBox.hidden = true; moreToggle.setAttribute('aria-expanded', 'false'); if (moreLabel) moreLabel.textContent = SIZES_LABEL; }
      }

      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }

      current = variant;
      idInput.value = variant.id;
      if (digitalBox) digitalBox.hidden = isDigital(variant.options[0]);
      var total = variant.price + addonCents();
      // Summary box lists the extras so the words match the price
      var sumExtras = section.querySelector('[data-sum-extras]');
      if (sumExtras) {
        var names = chosenAddons().map(function (a) {
          if (a.label === 'digital') return '+ Digital file';
          var n = parseInt(a.count, 10);
          return n >= 4 ? '+ 4 or more pets' : '+ ' + n + ' pets in one poster';
        });
        sumExtras.textContent = names.join(' · ');
        sumExtras.hidden = !names.length;
      }
      priceEl.textContent = formatMoney(total);
      var bnpl = section.querySelector('[data-bnpl-amount]');
      if (bnpl) bnpl.textContent = formatMoney(Math.round(total / 4));
      var bnplBtn = section.querySelector('[data-bnpl-btn]');
      if (bnplBtn) bnplBtn.textContent = formatMoney(Math.round(total / 4));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
      if (noteEl) noteEl.textContent = isDigital(variant.options[0]) ? data.digitalNote : data.printNote;
      addBtn.disabled = !variant.available;
      if (variant.available) { addLabel.innerHTML = 'Add to cart<span class="btn__perf" aria-hidden="true"></span><small class="btn__price">' + formatMoney(total) + '</small>'; } else { addLabel.textContent = 'Sold out'; }
      if (barPrice) barPrice.textContent = formatMoney(total) + ' · or 4 × ' + formatMoney(Math.round(total / 4));

      updateEta(isDigital(variant.options[0]));
      var noteDigital = section.querySelector('[data-format-note-digital]');
      var notePrint = section.querySelector('[data-format-note-print]');
      if (noteDigital) noteDigital.hidden = !isDigital(variant.options[0]);
      if (notePrint) notePrint.hidden = isDigital(variant.options[0]);

      // Variants carry the plain poster as their image (for cart/checkout/emails); keep the gallery where the customer left it.

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    /* Quick picks: the three common choices, with every other size one tap away */
    quickPicks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opts;
        try { opts = JSON.parse(btn.dataset.options); } catch (err) { return; }
        // Switching format keeps the size they chose if that format comes in it
        var keep = selected[0] !== opts[0] && variants.some(function (v) { return v.options[0] === opts[0] && v.options[1] === selected[1]; });
        selected = keep && !isDigital(opts[0]) ? [opts[0], selected[1]] : opts;
        render();
        if (wz) return;   // the wizard moves them on instead
        // Sizes open once they've chosen a printed format; Digital has no sizes
        if (moreBox) {
          var showSizes = !isDigital(opts[0]);
          if (showSizes && moreBox.hidden) {
            moreBox.hidden = false;
            moreBox.classList.remove('is-opening'); void moreBox.offsetWidth; moreBox.classList.add('is-opening');
          } else if (!showSizes) {
            moreBox.hidden = true;
          }
          if (sizePeek) sizePeek.hidden = true;  // sizes now open (or Digital): the shortcut row steps aside
        }
        guideTo(isDigital(opts[0]) || !moreBox ? nextAfterChoice() : moreBox, isDigital(opts[0]));
      });
    });
    // "Size: 45 × 60 cm · Change size" row under the format tiles: a second, obvious way into the sizes
    if (sizePeek && moreBox) sizePeek.addEventListener('click', function () {
      moreBox.hidden = false;
      moreBox.classList.remove('is-opening'); void moreBox.offsetWidth; moreBox.classList.add('is-opening');
      sizePeek.hidden = true;
      sizePeek.setAttribute('aria-expanded', 'true');
      guideTo(moreBox, false);
    });
    if (moreToggle && moreBox) {
      moreToggle.addEventListener('click', function () {
        var open = moreBox.hidden;
        moreBox.hidden = !open;
        moreToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (moreLabel) moreLabel.textContent = open ? 'Hide sizes' : SIZES_LABEL;
      });
    }

    section.addEventListener('click', function (e) {
      var picked = e.target.closest('[data-quick-pick], .more-options--nested .option-pill');
      if (picked) pop(picked);
    });

    groups.forEach(function (group) {
      var index = parseInt(group.dataset.optionIndex, 10);
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        selected[index] = btn.dataset.optionValue;
        render();
        if (wz) return;
        // Picked a size from the opened sizes: on to the next step
        if (moreBox && moreBox.contains(group) && index === 1) guideTo(nextAfterChoice(), true);
      });
    });

    /* 3-step wizard: one step open at a time; finished steps fold into a summary row with Change */
    if (wz) {
      var wzSteps = Array.prototype.slice.call(wz.querySelectorAll('[data-wz-step]'));
      var wzBuy = section.querySelector('.wz-buy');
      var wzDigital = wz.querySelector('[data-wz-digital]');
      var wzAt = 1;
      var money = function (c) { return formatMoney(c).replace(/\.00$/, ''); };
      var wzPaint = function () {
        var dig = isDigital(selected[0]);
        var pick = quickPicks.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
        var nameEl = pick && pick.querySelector('.quick-pick__name');
        wzSteps[0].querySelector('[data-wz-choice]').textContent = nameEl ? nameEl.firstChild.textContent.trim() : '';
        wzSteps[1].querySelector('[data-wz-choice]').textContent = dig ? 'Not needed' : (current ? current.options[1] + ' · ' + money(current.price) : '');
        var photos = fileInput && fileInput.files && fileInput.files.length;
        wzSteps[2].querySelector('[data-wz-choice]').textContent = photos ? 'Photo added' : 'Upload later';
        if (wzDigital) wzDigital.hidden = !dig;
      };
      var wzOpen = function (n, scroll) {
        wzAt = Math.max(1, Math.min(3, n));
        wzSteps.forEach(function (el, i) {
          var k = i + 1;
          el.classList.toggle('is-open', k === wzAt);
          el.classList.toggle('is-done', k < wzAt);
          el.classList.toggle('is-todo', k > wzAt);
          el.querySelector('[data-wz-head]').setAttribute('aria-expanded', k === wzAt ? 'true' : 'false');
        });
        if (wzBuy) wzBuy.classList.toggle('is-ready', wzAt === 3);
        wzPaint();
        if (scroll) {
          // Land with the step they just finished (now a one-line summary) in view above the new one
          var el = wzSteps[Math.max(0, wzAt - 2)];
          requestAnimationFrame(function () {
            el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });   // scroll-margin-top clears the sticky header
          });
        }
      };
      section.wzNext = function () { wzOpen(wzAt + 1, true); };
      section.wzAt = function () { return wzAt; };
      quickPicks.forEach(function (b) { b.addEventListener('click', function () { setTimeout(function () { wzOpen(2, true); }, 380); }); });
      groups.forEach(function (g) {
        if (g.dataset.optionIndex !== '1') return;
        g.addEventListener('click', function (e) { if (e.target.closest('[data-option-value]')) setTimeout(function () { wzOpen(3, true); }, 380); });
      });
      wz.addEventListener('click', function (e) {
        var h = e.target.closest('[data-wz-head]');
        if (h) { var n = parseInt(h.closest('[data-wz-step]').dataset.wzStep, 10); if (n !== wzAt) wzOpen(n, true); return; }
        if (e.target.closest('[data-wz-next]')) wzOpen(wzAt + 1, true);
      });
      if (fileInput) fileInput.addEventListener('change', wzPaint);
      wzOpen(1, false);
    }

    /* Delivery estimate with real dates */
    var eta = section.querySelector('[data-eta]');
    function addBusinessDays(date, days) {
      var d = new Date(date);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      return d;
    }
    function fmtDate(d) {
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
    }
    function updateEta(digital) {
      if (!eta) return;
      var proofDays = parseInt(eta.dataset.proofDays, 10) || 2;
      var printDays = parseInt(eta.dataset.printDays, 10) || 8;
      var proof = addBusinessDays(new Date(), proofDays);
      var final = digital ? proof : addBusinessDays(proof, 1 + printDays);
      eta.querySelector('[data-eta-proof]').textContent = fmtDate(proof);
      eta.querySelector('[data-eta-final]').textContent = digital ? 'Same day' : fmtDate(final);
      eta.querySelector('[data-eta-final-label]').textContent = digital ? 'Approve & download' : 'Framed at your door'.replace('Framed', /framed/i.test(selected[0]) ? 'Framed' : 'Printed');
      eta.querySelector('[data-eta-headline]').textContent = digital
        ? 'your preview lands by ' + fmtDate(proof)
        : 'it could be on your wall by ' + fmtDate(final);
      var note = digital ? '' : 'Estimate for Australia, based on approving your preview the day it arrives.';
      var festive = false;
      if (eta.dataset.xmasFrom && eta.dataset.xmasCutoff) {
        var now = new Date();
        var from = new Date(eta.dataset.xmasFrom + 'T00:00:00');
        var cut = new Date(eta.dataset.xmasCutoff + 'T23:59:59');
        var xmas = new Date(cut.getFullYear(), 11, 25);
        if (now >= from && now < xmas) {
          festive = true;
          if (digital) note = '🎄 Emailed to you, so it’s never too late for a Christmas gift.';
          else if (now <= cut) note = '🎄 Order by ' + fmtDate(cut) + ' for Christmas delivery in Australia.';
          else note = '🎄 Too late for a Christmas print in Australia. Choose Digital and it arrives by email in time.';
        }
      }
      eta.classList.toggle('eta--festive', festive);
      eta.querySelector('[data-eta-note]').textContent = note;
      var shortEl = section.querySelector('[data-eta-short]');
      if (shortEl) shortEl.textContent = digital ? 'In your inbox by ' + fmtDate(proof) : 'On your wall by ' + fmtDate(final);
      var giftEl = section.querySelector('[data-gift-line]');
      if (giftEl && !giftEl.hasAttribute('hidden')) {
        var xmasNow = festive && eta.dataset.xmasCutoff && new Date() <= new Date(eta.dataset.xmasCutoff + 'T23:59:59');
        giftEl.textContent = xmasNow && !digital ? 'Order by ' + fmtDate(new Date(eta.dataset.xmasCutoff + 'T12:00:00')) + ' for Christmas delivery' : "A gift they won't see coming.";
      }
    }

    /* Media slider (swipe on mobile, thumbs on desktop) */
    var track = section.querySelector('[data-slider-track]');
    var slideButtons = section.querySelectorAll('[data-slide-to]');
    function goTo(index, smooth) {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * index, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function markSlide(index) {
      slideButtons.forEach(function (b) {
        if (parseInt(b.dataset.slideTo, 10) === index) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }
    slideButtons.forEach(function (b) {
      b.addEventListener('click', function () { var i = parseInt(b.dataset.slideTo, 10); goTo(i); markSlide(i); });
    });
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { markSlide(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
      }, { passive: true });
    }
    function swapMedia(src) {
      if (!track || !src) return;
      var slides = track.querySelectorAll('img');
      for (var i = 0; i < slides.length; i++) {
        if ((slides[i].currentSrc || slides[i].src).split('?')[0].split('/').pop().replace(/_\d+x\d*/, '') === src.split('?')[0].split('/').pop()) {
          goTo(i); markSlide(i); return;
        }
      }
    }

    /* Sticky buy bar (phones): appears once they've picked a format, walks them through what's left */
    var bar = section.querySelector('[data-buy-bar]');
    var barPrice = bar && bar.querySelector('[data-buy-bar-price]');
    var anchor = section.querySelector('[data-buy-anchor]');
    if (bar && anchor) {
      var barBtn = bar.querySelector('[data-buy-bar-button]');
      var engaged = false, anchorVisible = false, anchorAbove = false;
      var nudged = {};
      var uploadGroup = fileInput && fileInput.closest('.field-group');
      var cardName = section.querySelector('[data-c-input="name"]');

      function nextStep() {
        if (section.wzAt && section.wzAt() < 3) {
          return { key: 'wz', run: section.wzNext, label: section.wzAt() === 1 ? 'Next: choose your size' : 'Next: upload your photo' };
        }
        if (uploadGroup && !(fileInput.files && fileInput.files.length) && !nudged.photo) {
          return { key: 'photo', el: uploadGroup, label: 'Next: add their photo' };
        }
        if (cardName && !cardName.value.trim() && !nudged.name) {
          return { key: 'name', el: cardName.closest('.card-builder__field') || cardName, label: 'Next: name on the card', focus: cardName };
        }
        return null;
      }
      function updateBar() {
        var step = nextStep();
        var v = variants.find(function (x) { return String(x.id) === idInput.value; });
        barBtn.innerHTML = step
          ? step.label + ' <span aria-hidden="true">&rarr;</span>'
          : 'Add to cart' + (v ? ' · ' + formatMoney(v.price + addonCents()) : '');
        var show = !anchorVisible && (engaged || anchorAbove);
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        barBtn.tabIndex = show ? 0 : -1;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          anchorVisible = e.isIntersecting;
          anchorAbove = !e.isIntersecting && e.boundingClientRect.top < 0;
          updateBar();
        }).observe(anchor);
      }
      section.addEventListener('click', function (e) {
        if (e.target.closest('[data-option-value], [data-card-style]')) engaged = true;
        setTimeout(updateBar, 0);
      });
      section.addEventListener('change', function () { setTimeout(updateBar, 0); });
      section.addEventListener('input', function () { setTimeout(updateBar, 0); });
      barBtn.addEventListener('click', function () {
        var step = nextStep();
        if (step && step.run) { step.run(); setTimeout(updateBar, 400); return; }
        if (step) {
          nudged[step.key] = true;
          step.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          step.el.classList.remove('is-attention');
          void step.el.offsetWidth;
          step.el.classList.add('is-attention');
          setTimeout(function () { step.el.classList.remove('is-attention'); }, 1800);
          if (step.focus) setTimeout(function () { step.focus.focus({ preventScroll: true }); }, 450);
          updateBar();
          return;
        }
        addBtn.click();
      });
      updateBar();
    }

    /* Upload preview */
    var MAX_BYTES = 20 * 1024 * 1024;
    if (fileInput) {
      var iconEl = upload.querySelector('[data-upload-icon]');
      var textEl = upload.querySelector('[data-upload-text]');
      var originalIcon = iconEl.innerHTML;
      var originalText = textEl.innerHTML;
      fileInput.addEventListener('change', function () {
        var file = fileInput.files && fileInput.files[0];
        upload.classList.remove('is-invalid');
        errorEl.textContent = '';
        if (!file) {
          upload.classList.remove('is-filled');
          iconEl.innerHTML = originalIcon;
          textEl.innerHTML = originalText;
          return;
        }
        if (file.size > MAX_BYTES) {
          fileInput.value = '';
          upload.classList.add('is-invalid');
          errorEl.textContent = 'That photo is over 20 MB. Please choose a smaller one.';
          return;
        }
        upload.classList.add('is-filled');
        if (/^image\/(jpeg|png|webp|gif)$/.test(file.type)) {
          var img = document.createElement('img');
          img.alt = '';
          img.src = photoUrl(fileInput) || URL.createObjectURL(file);
          iconEl.innerHTML = '';
          iconEl.appendChild(img);
        } else {
          iconEl.textContent = '✓';
        }
        // The poster preview keeps its "your pet here" outline; we don't drop their photo in (it read as the final result)
        var name = document.createElement('strong');
        name.textContent = file.name.length > 28 ? file.name.slice(0, 25) + '…' : file.name;
        var hint = document.createElement('small');
        hint.textContent = 'Looking good! Tap to change photo';
        textEl.innerHTML = '';
        textEl.appendChild(name);
        textEl.appendChild(hint);
        revealPreview();
        nudge(addBtn);
      });
    }

    /* "Your pet goes here" reveal after upload */
    var reveal = section.querySelector('[data-pp-reveal]');
    var nameInput = form.querySelector('[name="properties[Pet name]"]');
    function petLine() {
      if (!reveal) return;
      var n = nameInput ? nameInput.value.trim() : '';
      var memorial = reveal.dataset.memorial === 'true';
      reveal.querySelector('[data-pp-name]').textContent = n || 'your photo';
      reveal.querySelector('[data-pp-line]').textContent = memorial ? (n ? n + "'ll be right here" : "they'll be right here") : (n ? n + ' goes right here!' : 'your star goes here');
    }
    // One object URL per chosen file (reused for the upload thumbnail and the polaroid stack)
    var urls = new WeakMap();
    function photoUrl(input) {
      var f = input && input.files && input.files[0];
      if (!f || !/^image\//.test(f.type)) return null;
      var c = urls.get(input);
      if (c && c.f === f) return c.u;
      var u = URL.createObjectURL(f); urls.set(input, { f: f, u: u }); return u;
    }
    function chosenPhotos() {
      var list = [];
      if (fileInput) { var u0 = photoUrl(fileInput); if (u0) list.push(u0); }
      if (extraUploads && !extraUploads.hidden) extraUploads.querySelectorAll('[data-extra-upload]:not([hidden]) input[type="file"]').forEach(function (i) { var u = photoUrl(i); if (u) list.push(u); });
      return list;
    }
    function petsChosen() { var p = petBox && petBox.querySelector('input:checked'); return p ? parseInt(p.value, 10) : 1; }
    function petLine() {
      if (!reveal) return;
      var n = nameInput ? nameInput.value.trim() : '';
      var memorial = reveal.dataset.memorial === 'true';
      var many = petsChosen() > 1;
      reveal.querySelector('[data-pp-name]').textContent = many ? 'your pets' : (n || 'your photo');
      reveal.querySelector('[data-pp-line]').textContent = many
        ? (memorial ? "they'll be right here" : 'your pets go here')
        : (memorial ? (n ? n + "'ll be right here" : "they'll be right here") : (n ? n + ' goes right here!' : 'your star goes here'));
    }
    // Fanned stack of polaroids behind the main one, one per extra photo
    function renderStack() {
      if (!reveal) return;
      var top = reveal.querySelector('.pp-reveal__polaroid:not(.pp-reveal__polaroid--back)');
      var photos = chosenPhotos();
      reveal.querySelectorAll('.pp-reveal__polaroid--back').forEach(function (el) { el.remove(); });
      var img = reveal.querySelector('[data-pp-photo]');
      if (photos[0]) { img.src = photos[0]; img.hidden = false; }
      var fan = [[8, -14, 7], [-3, 12, -12], [14, -24, -2]];   // rotate, x%, y px for cards 2-4
      photos.slice(1, 4).forEach(function (u, n) {
        var back = document.createElement('div');
        back.className = 'pp-reveal__polaroid pp-reveal__polaroid--back';
        back.setAttribute('aria-hidden', 'true');
        back.style.setProperty('--r', fan[n][0] + 'deg'); back.style.setProperty('--x', fan[n][1] + '%'); back.style.setProperty('--y', fan[n][2] + 'px');
        back.style.zIndex = 1 - n;
        back.innerHTML = '<img alt="" src="' + u + '">';
        top.parentNode.insertBefore(back, top);
      });
      reveal.classList.toggle('pp-reveal--many', photos.length > 1);
      petLine();
      if (photos.length && reveal.hidden) {
        reveal.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { reveal.classList.add('is-in'); }); });
      }
    }
    function revealPreview() { renderStack(); }
    if (nameInput) nameInput.addEventListener('input', petLine);
    if (reveal) {
      var changeBtn = reveal.querySelector('[data-pp-change]');
      if (changeBtn && fileInput) changeBtn.addEventListener('click', function () { fileInput.click(); });
    }


    /* Submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.textContent = '';

      if (fileInput && fileInput.hasAttribute('data-required') && !(fileInput.files && fileInput.files.length)) {
        upload.classList.add('is-invalid');
        errorEl.textContent = 'Please add a photo of your pet first.';
        upload.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      addBtn.classList.add('is-loading');
      addBtn.disabled = true;

      var body = new FormData(form);
      if (fileInput && !(fileInput.files && fileInput.files.length)) {
        body.delete(fileInput.name);
        body.append(fileInput.name, 'Emailing it after checkout');
      }
      // Swap each chosen photo for its shrunk copy (already prepared when it was picked)
      var photoInputs = Array.prototype.slice.call(form.querySelectorAll('input[type="file"][name^="properties[Pet photo"]')).filter(function (i) { return i.files && i.files.length && !i.closest('[hidden]'); });
      var photosReady = Promise.all(photoInputs.map(function (i) {
        return preparePhoto(i).then(function (f) { if (f) { body.delete(i.name); body.append(i.name, f, f.name); } });
      }));
      // Extras (pets, digital file) go in as their own lines, tagged to this poster
      var addons = chosenAddons();
      var petCount = petBox && petBox.querySelector('input:checked');
      if (petCount && petCount.value !== '1') body.append('properties[Pets]', petCount.value === '4' ? '4 or more' : petCount.value);
      if (addons.some(function (a) { return a.label === 'digital'; })) body.append('properties[Digital file]', 'Added');
      if (extraUploads) extraUploads.querySelectorAll('[data-extra-upload][hidden] input[type="file"]').forEach(function (i) { body.delete(i.name); });
      var ref = String(Date.now()).slice(-6);
      if (addons.length) body.append('properties[_extras]', ref);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      var design = (document.querySelector('.product__title') || {}).textContent || document.title;
      // One request: the poster (with its photos) and its extras together, and the refreshed cart back
      function asItems(fd) {
        var out = new FormData();
        fd.forEach(function (v, k) {
          if (k === 'id' || k === 'quantity' || k === 'selling_plan') out.append('items[0][' + k + ']', v);
          else if (k.indexOf('properties[') === 0) out.append('items[0][' + k.replace(/^properties\[(.*)\]$/, 'properties][$1') + ']', v);
          else if (k === 'sections' || k === 'sections_url') out.append(k, v);
        });
        if (!out.has('items[0][quantity]')) out.append('items[0][quantity]', '1');
        addons.forEach(function (a, n) {
          var i = n + 1;
          out.append('items[' + i + '][id]', a.id);
          out.append('items[' + i + '][quantity]', '1');
          out.append('items[' + i + '][properties][For]', design.trim());
          out.append('items[' + i + '][properties][_extras]', ref);
        });
        return out;
      }
      // Feels instant: open the cart straight away with the poster "being added", then fill it in
      var hasPhoto = photoInputs.length > 0;
      var straight = form.getAttribute('data-straight-checkout') === 'true';
      var leaving = false;
      if (Cart.drawer && !straight) {
        var bodyEl = Cart.drawer.querySelector('.drawer__body');
        var tImg = section.querySelector('.mini--print img, .mini img') || section.querySelector('.product-slider img');
        var thumb = tImg ? (tImg.currentSrc || tImg.getAttribute('src') || '') : '';
        var pending = document.createElement('div');
        pending.className = 'cart-adding';
        pending.innerHTML = '<span class="cart-adding__img">' + (thumb ? '<img src="' + thumb + '" alt="">' : '') + '</span><span class="cart-adding__text"><strong>Adding ' + design.trim().replace(/</g, '') + '…</strong><span>' + (hasPhoto ? 'Uploading your photo, just a moment' : 'Just a moment') + '</span><i></i></span>';
        if (bodyEl) { var empty = bodyEl.querySelector('.cart-empty'); if (empty) empty.hidden = true; bodyEl.prepend(pending); bodyEl.scrollTop = 0; }
        Cart.open();
      }
      photosReady.then(function () {
        return fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: addons.length ? asItems(body) : body
        });
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            var p0 = Cart.drawer && Cart.drawer.querySelector('.cart-adding'); if (p0) p0.remove();
            if (Cart.isOpen()) Cart.close();
            errorEl.textContent = res.json.description || res.json.message || 'Something went wrong. Please try again.';
            return;
          }
          if (straight) { leaving = true; window.location.href = '/checkout'; return; }
          if (res.json.sections && Cart.drawer) {
            Cart.render(res.json.sections['cart-drawer']);
            if (!Cart.isOpen()) Cart.open();
          } else {
            window.location.href = theme.routes.cart;
          }
        })
        .catch(function () {
          // Fall back to a normal form post (handles very old browsers / network quirks).
          form.submit();
        })
        .finally(function () {
          if (leaving) return;   // keep the spinner while checkout loads
          addBtn.classList.remove('is-loading');
          addBtn.disabled = !current.available;
        });
    });

    render();
  }

  /* ---------- Swipe rails with dots ---------- */
  function initRails(root) {
    (root || document).querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      var dotsWrap = rail.querySelector('[data-rail-dots]');
      if (!track || !dotsWrap || dotsWrap.childElementCount) return;
      var items = track.children;
      for (var i = 0; i < items.length; i++) {
        var dot = document.createElement('span');
        dot.className = 'rail__dot';
        if (i === 0) dot.setAttribute('aria-current', 'true');
        dotsWrap.appendChild(dot);
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestDist = Infinity;
          for (var j = 0; j < items.length; j++) {
            var c = items[j].offsetLeft + items[j].offsetWidth / 2;
            var d = Math.abs(c - center);
            if (d < bestDist) { bestDist = d; best = j; }
          }
          Array.prototype.forEach.call(dotsWrap.children, function (el, k) {
            if (k === best) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
          });
        }, 60);
      }, { passive: true });
    });
  }

  /* ---------- Site-wide sticky CTA (phones) ---------- */
  function initStickyCta() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;
    var hero = document.querySelector('[data-hero]');
    var link = bar.querySelector('a');
    function set(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      link.tabIndex = show ? 0 : -1;
    }
    var heroCta = hero && hero.querySelector('.hero__cta .btn');
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { set(!entries[0].isIntersecting); }, { threshold: heroCta ? 0 : 0.15 }).observe(heroCta || hero);
    } else {
      window.addEventListener('scroll', function () { set(window.scrollY > 400); }, { passive: true });
    }
  }

  /* ---------- Cart gift note ---------- */
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(theme.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  /* ---------- Before / after sliders ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-compare]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var input = el.querySelector('input[type="range"]');
      function set(v) { el.style.setProperty('--pos', v + '%'); }
      input.addEventListener('input', function () { el.dataset.touched = '1'; set(input.value); });

      // One gentle "peek" the first time it's on screen, so people know it moves.
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var start = null, dur = 1600;
        function frame(t) {
          if (el.dataset.touched) return;
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var v = 50 + Math.sin(p * Math.PI * 2) * 22 * (1 - p);
          set(v.toFixed(1)); input.value = v;
          if (p < 1) requestAnimationFrame(frame);
        }
        setTimeout(function () { requestAnimationFrame(frame); }, 500);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  /* ---------- Size guide dialog ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-size-guide-open]');
    if (open) {
      var dlg = document.getElementById(open.getAttribute('aria-controls'));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var close = e.target.closest('[data-size-guide-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Prize pop-up ---------- */
  function initPrize() {
    try { var won = JSON.parse(localStorage.getItem('pc_prize_claimed') || 'null'); if (won && won.code === 'BONUSPOSTER') document.documentElement.classList.add('has-bonus'); } catch (e) {}
    var root = document.querySelector('[data-prize]');
    if (!root) return;
    var KEY_DISMISS = 'pc_prize_dismissed', KEY_CLAIMED = 'pc_prize_claimed', KEY_PENDING = 'pc_prize_pending';
    var store = {
      get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    };
    var params = new URLSearchParams(location.search);
    var force = params.get('prize') === '1';
    var pets = root.querySelectorAll('[data-prize-pet]');
    var email = root.querySelector('[data-prize-email]');
    var submit = root.querySelector('[data-prize-submit]');
    var tags = root.querySelector('[data-prize-tags]');
    var hint = root.querySelector('[data-prize-hint]');
    var form = root.querySelector('[data-prize-form]');
    var chosen = null;
    var lastFocus = null;

    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('no-scroll');
      document.documentElement.classList.add('prize-open');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      root.querySelector('.prize__sheet').focus();
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      document.documentElement.classList.remove('prize-open');
      setTimeout(function () { root.hidden = true; }, 250);
      if (!store.get(KEY_CLAIMED)) store.set(KEY_DISMISS, String(Date.now()));
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    var quiz = root.dataset.mode === 'quiz';
    function step(name) {
      root.querySelectorAll('[data-prize-step]').forEach(function (el) { el.hidden = el.dataset.prizeStep !== name; });
    }
    // Quiz: last screen, sending them to the movie that matches their pet
    function quizDone(prize, texted) {
      step('won');
      root.querySelector('[data-prize-won-title]').textContent = "You're all set!";
      var code = root.dataset.offerCode;
      var dest = prize.url || location.pathname;
      root.querySelector('[data-prize-won-detail]').textContent = (texted ? "We'll text you when your proof is ready. " : '') + 'Your 10% off is ready. Tap below and it comes off automatically' + (prize.movie ? ' on ' + prize.movie : '') + '.';
      root.querySelector('[data-prize-apply]').href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
    }
    // Their movie goes in the middle; the two side posters are other movies, never a repeat
    function quizArt(img) {
      var mid = root.querySelector('[data-quiz-img]');
      if (!mid || !img) return;
      mid.src = img;
      var others = Array.prototype.map.call(root.querySelectorAll('[data-quiz-pick]'), function (b) { return b.dataset.img; })
        .filter(function (u) { return u && u !== img; });
      root.querySelectorAll('[data-quiz-side]').forEach(function (el, i) { if (others[i]) el.src = others[i]; });
    }
    function showWon(prize) {
      if (quiz) {
        // After the email sign-up: straight to the code (the mobile-number step was removed 8 Oct 2026)
        if (prize.img) quizArt(prize.img);
        quizDone(prize, false);
        return;
      }
      root.querySelector('[data-prize-step="choose"]').hidden = true;
      root.querySelector('[data-prize-step="won"]').hidden = false;
      root.querySelector('[data-prize-won-title]').textContent = prize.title + '!';
      root.querySelector('[data-prize-won-detail]').textContent = prize.detail;
      var codeEl = root.querySelector('[data-prize-code]');
      if (codeEl) codeEl.textContent = prize.code;
      var back = document.querySelector('[data-product-form]') ? location.pathname + location.search : (root.dataset.redirect || '/');
      root.querySelector('[data-prize-apply]').href = prize.code ? '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(back) : back;
    }

    var KEY_PICK = 'pc_prize_pick';
    var prizes = [];
    try { prizes = JSON.parse(root.querySelector('[data-prize-list]').textContent); } catch (e) {}
    if (root.dataset.mode === 'offer' && prizes[0]) chosen = prizes[0];
    function drawPrize() {
      var total = prizes.reduce(function (t, p) { return t + (p.weight || 1); }, 0);
      var r = Math.random() * total;
      for (var i = 0; i < prizes.length; i++) { r -= (prizes[i].weight || 1); if (r <= 0) return prizes[i]; }
      return prizes[prizes.length - 1];
    }
    function lockIn(pet, prize, animate) {
      chosen = { code: prize.code, title: prize.title, detail: prize.detail, pet: pet.dataset.petName };
      pets.forEach(function (p) { p.setAttribute('aria-checked', p === pet ? 'true' : 'false'); p.disabled = true; });
      pet.querySelector('[data-prize-won-label]').textContent = prize.title;
      root.classList.add('has-choice');
      if (animate) { requestAnimationFrame(function () { pet.classList.add('is-flipped'); }); } else { pet.classList.add('is-flipped'); }
      email.disabled = false; submit.disabled = false;
      submit.textContent = 'Claim ' + prize.title;
      hint.textContent = 'You found ' + prize.detail.replace(/\.$/, '') + '! Enter your email to claim it.';
      tags.value = 'newsletter,popup-prize,prize-' + prize.code;
    }
    // One pick per person: restore an earlier pick
    try {
      var saved = JSON.parse(store.get(KEY_PICK) || 'null');
      if (saved && pets[saved.index]) lockIn(pets[saved.index], saved.prize, false);
    } catch (e) {}

    pets.forEach(function (pet, index) {
      pet.addEventListener('click', function () {
        if (chosen || !prizes.length) return;
        var prize = drawPrize();
        store.set(KEY_PICK, JSON.stringify({ index: index, prize: prize }));
        lockIn(pet, prize, true);
        setTimeout(function () { email.focus({ preventScroll: true }); }, 650);
      });
    });

    // Personal one-use code (e.g. PAW7K2QX). Shopify Flow reads the tag and creates the discount.
    function personalCode(prefix) {
      var chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789', out = '';
      var rand = new Uint32Array(6);
      (window.crypto || window.msCrypto).getRandomValues(rand);
      for (var i = 0; i < rand.length; i++) out += chars[rand[i] % chars.length];
      return prefix + out;
    }
    // Quiz: pick a personality, then the email step for the matching movie
    var baseTags = tags ? tags.value : '';
    if (quiz) {
      root.addEventListener('click', function (e) {
        var pick = e.target.closest('[data-quiz-pick]');
        if (pick) {
          chosen = { code: '', title: 'All set', detail: '', persona: pick.dataset.persona, movie: pick.dataset.movie, url: pick.dataset.url, img: pick.dataset.img };
          tags.value = baseTags + ',persona-' + pick.dataset.persona.toLowerCase().replace(/^the /, '').replace(/[^a-z]+/g, '-');
          quizArt(pick.dataset.img);
          step('email');
          setTimeout(function () { email.focus({ preventScroll: true }); }, 200);
          return;
        }
        if (e.target.closest('[data-quiz-back]')) step('choose');
      });
    }
    form.addEventListener('submit', function () {
      if (chosen && email) chosen.email = email.value;
      if (chosen && root.dataset.creditPrefix) {
        chosen = { code: personalCode(root.dataset.creditPrefix), title: chosen.title, detail: chosen.detail };
        tags.value = 'newsletter,popup-credit,credit-' + chosen.code;
      }
      if (chosen) store.set(KEY_PENDING, JSON.stringify(chosen));
    });

    // Footer sign-ups get the same personal $15 code as the pop-up (Flow creates it from the tag),
    // and the pop-up shows the code when they land back on the page.
    var footerForm = document.getElementById('FooterNewsletter');
    if (footerForm && ((root.dataset.mode === 'offer' && prizes[0]) || quiz)) {
      footerForm.addEventListener('submit', function () {
        if (store.get(KEY_CLAIMED)) return;
        var footerTags = footerForm.querySelector('input[name="contact[tags]"]');
        var offer = quiz ? { code: '', title: 'All set', detail: '' } : { code: prizes[0].code, title: prizes[0].title, detail: prizes[0].detail };
        var fe = footerForm.querySelector('input[type="email"]'); if (fe) offer.email = fe.value;
        if (root.dataset.creditPrefix) {
          offer.code = personalCode(root.dataset.creditPrefix);
          if (footerTags) footerTags.value = 'newsletter,popup-credit,footer-signup,credit-' + offer.code;
        } else if (footerTags && tags) {
          footerTags.value = tags.value + ',footer-signup';
        }
        store.set(KEY_PENDING, JSON.stringify(offer));
      });
    }

    root.addEventListener('click', function (e) { if (e.target.closest('[data-prize-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') close();
      else trapFocus(root.querySelector('.prize__sheet'), e);
    });
    var copyBtn = root.querySelector('[data-prize-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function (e) {
      var code = root.querySelector('[data-prize-code]').textContent;
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      e.target.textContent = 'Copied!';
    });

    // Came back from a successful sign-up
    var pending = store.get(KEY_PENDING);
    if (params.get('customer_posted') === 'true' && pending) {
      try { var prize = JSON.parse(pending); store.set(KEY_CLAIMED, JSON.stringify(prize)); showWon(prize); open(); } catch (e) {}
      try { localStorage.removeItem(KEY_PENDING); } catch (e) {}
      return;
    }
    // Back from some other sign-up (e.g. the free preview form): don't pop over them
    if (params.get('customer_posted') === 'true') return;
    // Form error (e.g. invalid email): reopen so they can fix it
    if (root.querySelector('[data-prize-error]')) { if (quiz) step('email'); open(); return; }

    if (force) { open(); return; }
    if (store.get(KEY_CLAIMED)) return;
    var dismissed = parseInt(store.get(KEY_DISMISS) || '0', 10);
    var cooldown = (parseInt(root.dataset.cooldown, 10) || 14) * 864e5;
    if (dismissed && Date.now() - dismissed < cooldown) return;
    if (/\/cart|\/pages\/proof/.test(location.pathname)) return;

    function autoOpen() {
      // Don't pop over someone typing or picking a photo
      var active = document.activeElement;
      if (document.visibilityState === 'hidden' || (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName))) return;
      open();
    }
    var onProduct = !!document.querySelector('[data-product-form]');
    // Product pages: 13s or halfway scroll (most ad visitors browse then leave), or as they go to leave (desktop)
    var timer = setTimeout(autoOpen, onProduct ? 13000 : (parseInt(root.dataset.delay, 10) || 12) * 1000);
    if (onProduct) {
      document.addEventListener('mouseout', function leave(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', leave); clearTimeout(timer); autoOpen(); }
      });
    }
    function cancel() { clearTimeout(timer); window.removeEventListener('scroll', onScroll); }
    function onScroll() {
      var depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (depth > 0.5) { cancel(); autoOpen(); }
    }
    // On the product page, stand down once they've really started an order: picking a photo or typing
    // card details (claiming reloads the page, which would lose them). Tapping a format or size doesn't count.
    var productForm = document.querySelector('[data-product-form]');
    if (productForm) {
      productForm.addEventListener('pointerdown', function (e) { if (e.target.closest('[data-upload], input[type="file"]')) cancel(); });
      productForm.addEventListener('change', function (e) { if (e.target.type === 'file') cancel(); });
      productForm.addEventListener('input', function (e) { if (e.target.tagName === 'TEXTAREA' || /^(text|number|email|search)$/.test(e.target.type)) cancel(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // Never interrupt someone who has just added to cart
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-add-button], [data-cart-toggle]')) cancel();
    });
  }

  /* ---------- Trading card builder ---------- */
  var CARD_MOVES = {
    'Selective Hearing': 'Ignores every command within three metres of a snack.',
    'Puppy Eyes': 'Reduces any human\u2019s resistance to zero. Works every time.',
    'Sock Heist': 'Takes one sock from every pair. Never returns it.',
    'Couch Takeover': 'Occupies 90% of the couch with 10% of the body.',
    'The Lean': 'Leans on you, slowly, until you give in.',
    'Dinner Stare': 'Unblinking gaze until a chip falls. A chip always falls.',
    'Shake Attack': 'Waits until right beside you to shake off the bath.',
    'The 9pm Zoomies': 'Hits top speed indoors for no reason whatsoever.'
  };
  function initCardBuilder(root) {
    (root || document).querySelectorAll('[data-card-builder]').forEach(function (el) {
      var card = el.querySelector('[data-card-preview]');
      function q(sel) { return el.querySelectorAll(sel); }
      function setText(sel, value) { q(sel).forEach(function (n) { n.textContent = value; }); }
      function update() {
        var style = (el.querySelector('[data-card-style]:checked') || {}).value || 'Holo';
        var key = style.toLowerCase();
        card.className = 'pcard pcard--' + key;
        el.querySelector('.card-builder__preview').dataset.style = key;
        card.style.backgroundImage = 'url(' + card.dataset['frame' + style] + ')';
        var name = el.querySelector('[data-c-input="name"]').value.trim() || 'Biscuit';
        setText('[data-c-name]', name);
        setText('[data-c-badge]', el.querySelector('[data-c-input="badge"]').value);
        // Only show (and submit) the choices this card style actually uses
        q('[data-c-for]').forEach(function (n) {
          var on = n.dataset.cFor.split(' ').indexOf(key) > -1;
          n.hidden = !on;
          n.querySelectorAll('input, select').forEach(function (i) { i.disabled = !on; });
        });
        el.querySelector('[data-c-row]').classList.toggle('is-single', key !== 'holo');
        setText('[data-c-type]', (el.querySelector('[data-c-type-opt]:checked') || {}).value || '');
        var move = (el.querySelector('[data-c-move-opt]:checked') || {}).value || '';
        setText('[data-c-move]', move);
        setText('[data-c-desc]', CARD_MOVES[move] || '');
        var total = 0, count = 0;
        q('[data-c-stat]').forEach(function (input) {
          var k = input.dataset.cStat, v = parseInt(input.value, 10);
          setText('[data-c-val="' + k + '"], [data-c-out="' + k + '"]', v);
          input.style.setProperty('--v', ((v - 1) / 98 * 100) + '%');
          q('[data-c-bar="' + k + '"]').forEach(function (b) { b.style.width = v + '%'; });
          if (k !== 'obedience' && !input.disabled) { total += v; count++; }
        });
        var overall = Math.round(total / Math.max(count, 1));
        setText('[data-c-overall]', overall);
        el.querySelector('[data-c-overall-input]').value = overall;
      }
      function pick(list) { return list[Math.floor(Math.random() * list.length)]; }
      el.addEventListener('input', update);
      el.addEventListener('change', update);
      el.querySelector('[data-c-surprise]').addEventListener('click', function () {
        ['[data-c-type-opt]', '[data-c-move-opt]'].forEach(function (sel) {
          var opts = q(sel);
          var chosen = opts[Math.floor(Math.random() * opts.length)];
          chosen.checked = true;
          chosen.closest('.cb-chip').scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        });
        q('[data-c-stat]').forEach(function (input) {
          input.value = input.dataset.cStat === 'obedience' ? 2 + Math.floor(Math.random() * 38) : 70 + Math.floor(Math.random() * 30);
        });
        update();
      });
      update();
    });
  }

  /* ---------- Shopify Inbox: keep the chat button above our sticky bars ---------- */
  function initChatOffset() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-sticky-cta], .buy-bar'));
    if (!bars.length) return;
    function update() {
      var offset = 0;
      bars.forEach(function (bar) {
        if (!bar.classList.contains('is-visible')) return;
        // Use the bar's resting size, not its mid-animation position
        var gap = parseFloat(getComputedStyle(bar).bottom) || 0;
        offset = Math.max(offset, bar.offsetHeight + gap + 10);
      });
      document.documentElement.style.setProperty('--pc-chat-offset', (offset || 20) + 'px');
    }
    var mo = new MutationObserver(update);
    bars.forEach(function (bar) { mo.observe(bar, { attributes: true, attributeFilter: ['class'] }); });
    window.addEventListener('resize', update);
    update();
    function patch(tries) {
      var chat = document.querySelector('shopify-chat');
      var root = chat && chat.shadowRoot;
      if (!root) { if (tries < 40) setTimeout(function () { patch(tries + 1); }, 500); return; }
      if (root.querySelector('style[data-pc]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-pc', '');
      st.textContent = '.activator-nudge{bottom:var(--pc-chat-offset,20px)!important;transition:opacity .2s!important;opacity:var(--pc-chat-op,1)!important;pointer-events:var(--pc-chat-pe,auto)!important}';
      root.appendChild(st);
    }
    patch(0);
    // "Questions? Message us" under Add to cart: open the Inbox chat if it's loaded, otherwise the contact page
    document.querySelectorAll('[data-open-chat]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var chat = document.querySelector('shopify-chat');
        var btn = chat && chat.shadowRoot && chat.shadowRoot.querySelector('button.activator');
        if (!btn) return;
        e.preventDefault();
        btn.click();
      });
    });
    // Product pages: keep the chat bubble off the buy box. Phones: hidden until they've scrolled past the
    // Add to cart button (it then sits above the sticky bar). Desktop: hidden only while the button is on screen.
    var cta = document.querySelector('[data-add-button]');
    if (cta) {
      var hideChat = function (on) {
        document.documentElement.style.setProperty('--pc-chat-op', on ? '0' : '1');
        document.documentElement.style.setProperty('--pc-chat-pe', on ? 'none' : 'auto');
      };
      var checkChat = function () {
        var r = cta.getBoundingClientRect();
        if (window.innerWidth < 900) hideChat(r.bottom > 0);
        else hideChat(r.top < window.innerHeight - 40 && r.bottom > 0);
      };
      window.addEventListener('scroll', checkChat, { passive: true });
      window.addEventListener('resize', checkChat);
      checkChat();
    }
  }

  /* ---------- Ticket buttons: split "Label from $39" into label | tear-off | price ---------- */
  function initTickets(root) {
    (root || document).querySelectorAll('a.btn--gold:not([data-ticket])').forEach(function (btn) {
      var text = btn.textContent.replace(/\s+/g, ' ').trim();
      var m = text.match(/^(.*?)\s+(from\s+\S+)$/i);
      if (!m) return;
      btn.setAttribute('data-ticket', '');
      btn.textContent = '';
      var label = document.createElement('span'); label.textContent = m[1];
      var perf = document.createElement('span'); perf.className = 'btn__perf'; perf.setAttribute('aria-hidden', 'true');
      var price = document.createElement('small'); price.className = 'btn__price'; price.textContent = m[2];
      btn.append(label, perf, price);
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initMenu();
    initTickets();
    initRails();
    initCompare();
    initStickyCta();
    initPrize();
    initCardBuilder();
    initDeferred();
    initBnplAmount();
    initSectionFade();
    initChatOffset();
    Cart.init();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  }

  /* ---------- Afterpay + Zip app blocks: use the price the section shows ---------- */
  // The app blocks default to the product's first variant; homepage slots pass their own "from" price.
  function initBnplAmount() {
    document.querySelectorAll('[data-bnpl-amount]').forEach((slot) => {
      const amount = slot.dataset.bnplAmount;
      slot.querySelectorAll('square-placement, afterpay-placement').forEach((el) => el.setAttribute('data-amount', amount));
      slot.querySelectorAll('[data-zm-widget]').forEach((el) => { el.setAttribute('data-zm-price', amount); el.setAttribute('amount', amount); });
    });
  }

  /* ---------- Premiere Pack quick add (cart) ---------- */
  // Adds a desk-size (15x20) copy of any design using the full-size print's photo and pet name.
  (function () {
    function box(el) { return el.closest('[data-pack]'); }
    function sel(b, name) { return b.querySelector('[data-pack-' + name + ']:checked'); }
    function paint(b) {
      var f = sel(b, 'format'), out = b.querySelector('[data-pack-price]');
      if (f && out) out.textContent = f.dataset.price;
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-pack-open]');
      if (open) {
        var b = box(open), q = b.querySelector('[data-pack-quick]');
        q.hidden = false; open.hidden = true; open.setAttribute('aria-expanded', 'true');
        paint(b);
        return;
      }
      var add = e.target.closest('[data-pack-add]');
      if (!add) return;
      var b2 = box(add), q2 = b2.querySelector('[data-pack-quick]'), err = b2.querySelector('[data-pack-error]');
      var d = sel(b2, 'design'), f = sel(b2, 'format');
      if (!d || !f) { err.textContent = 'Pick a design and a finish.'; return; }
      var id = parseInt(f.value === 'framed' ? d.dataset.framed : d.dataset.print, 10);
      if (!id) { err.textContent = 'That one is not available right now.'; return; }
      var props = { 'Premiere Pack': 'Desk-size copy' };
      if (q2.dataset.photo) props['Pet photo'] = q2.dataset.photo;
      if (q2.dataset.pet) props['Pet name'] = q2.dataset.pet;
      if (q2.dataset.title) props['Movie title'] = q2.dataset.title;
      add.disabled = true; err.textContent = '';
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }], sections: 'cart-drawer' })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (data) {
          if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
          if (data.sections) Cart.render(data.sections['cart-drawer']);
        })
        .catch(function () { add.disabled = false; err.textContent = 'Something went wrong. Please try again.'; });
    });
    document.addEventListener('change', function (e) { if (e.target.closest('[data-pack-format]')) paint(box(e.target)); });
  })();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    initRails(e.target);
    initCompare(e.target);
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
    if (e.target.querySelector('[data-cart-drawer]')) Cart.drawer = document.querySelector('[data-cart-drawer]');
  });
})();
